import { Menu } from 'semantic-ui-react';

export default Menu;
